import * as React from 'react';
import classnames from 'classnames';

const StickyCallToAction = ({ price , priceSubtitle , button , className  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('sticky-call-to-action', {
            'sticky-call-to-action--no-price': !price
        }, className)
    }, price && /*#__PURE__*/ React.createElement("div", {
        className: "sticky-call-to-action__price-info"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "sticky-call-to-action__price"
    }, price), priceSubtitle && /*#__PURE__*/ React.createElement("span", {
        className: "sticky-call-to-action__price-subtitle"
    }, priceSubtitle)), button)
;
var StickyCallToAction$1 = StickyCallToAction;

export { StickyCallToAction$1 as default };
//# sourceMappingURL=StickyCallToAction.js.map
